import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import ar from "./ar.json";

const SAVED = typeof localStorage !== "undefined" ? localStorage.getItem("cb_lang") : null;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    lng: SAVED || undefined,
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    interpolation: { escapeValue: false },
  });

export function applyDir(lang) {
  const dir = lang === "ar" ? "rtl" : "ltr";
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
  }
}

applyDir(i18n.language || "en");

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("cb_lang", lng);
  applyDir(lng);
});

export default i18n;
